import { render, staticRenderFns } from "./BillarReportDetail.vue?vue&type=template&id=1d7acce5"
import script from "./BillarReportDetail.vue?vue&type=script&lang=js"
export * from "./BillarReportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports